/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateKno2InfoRequest
 */
export interface CreateKno2InfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    last_name: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateKno2InfoRequest
     */
    birth_date: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    zip_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateKno2InfoRequest
     */
    country?: string;
}

/**
 * Check if a given object implements the CreateKno2InfoRequest interface.
 */
export function instanceOfCreateKno2InfoRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "birth_date" in value;

    return isInstance;
}

export function CreateKno2InfoRequestFromJSON(json: any): CreateKno2InfoRequest {
    return CreateKno2InfoRequestFromJSONTyped(json, false);
}

export function CreateKno2InfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateKno2InfoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'birth_date': (new Date(json['birth_date'])),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip_code': !exists(json, 'zip_code') ? undefined : json['zip_code'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function CreateKno2InfoRequestToJSON(value?: CreateKno2InfoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'birth_date': (value.birth_date.toISOString().substring(0,10)),
        'gender': value.gender,
        'street': value.street,
        'city': value.city,
        'state': value.state,
        'zip_code': value.zip_code,
        'country': value.country,
    };
}

